import s from "./style.module.css";
import Animation from "./animation/Animation"; // Ensure this path is correct
import { useEffect, useState } from "react";

export default function Competences() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const presentation = () => {
    return (
      <>
        Fort de{" "}
        <span className={`${s.highlight}`}>plusieurs années d'expérience </span>
        dans le développement de solutions numériques pour de grandes
        entreprises, j'apporte une{" "}
        <span className={`${s.highlight}`}>
          expertise technique solide
        </span>{" "}
        alliée à un véritable souci de la{" "}
        <span className={`${s.highlight}`}>qualité</span>. Habitué à évoluer
        dans des environnements fonctionels complexes, je mets un point
        d'honneur à comprendre les enjeux métiers de chaque client pour
        concevoir des solutions{" "}
        <span className={`${s.highlight}`}>sur mesure</span>,{" "}
        <span className={`${s.highlight}`}>fiables</span> et{" "}
        <span className={`${s.highlight}`}>évolutives</span>. J'aime
        particulièrement travailler en équipe pour transformer les défis
        techniques en <span className={`${s.highlight}`}>succès partagés</span>.
        Voici un aperçu du périmètre sur lequel s'étend mon domaine de
        compétence.
      </>
    );
  };

  const technos = () => {
    return (
      <>
        <span className={`${s.title}`}>Back-end</span>
        <span className={`${s.subTitle}`}>
          Java <span className={`${s.version}`}>(versions 8 à 21)</span> :{" "}
        </span>
        Spring <span className={`${s.version}`}>(v. 5 à 6)</span>, Spring Boot,
        Spring MVC, Spring Data JPA, Spring Security, Hibernate, Swing,
        MapStruct, JMS/ActiveMq, Liquibase, H2, jUnit, Mockito, Vault, Apache
        POI..
        <br />
        <span className={`${s.subTitle}`}>Node.js : </span>Express, Axios, EJS,
        Mongoose..
        <span className={`${s.title} mt-3`}>Front-end</span>
        Angular <span className={`${s.version}`}>(v. 15 à 18)</span>, React{" "}
        <span className={`${s.version}`}>(v. 16 à 18)</span>, HTML, CSS,
        JavaScript, TypeScript, Bootstrap, Tailwind, Responsive design..
        <span className={`${s.title} mt-3`}>Database</span>Oracle, mySQL,
        PostgreSQL, MongoDB
        <span className={`${s.title} mt-3`}>Intégration continue</span>Maven,
        GitHub, Jenkins, SonarQ, Docker, Jira, Trello, Bamboo, Bitbucket
        <span className={`${s.title} mt-3`}>IDE</span>Eclipse, IntelliJ, vsCode,
        WebStorm
        <span className={`${s.title} mt-3`}>Méthodologie</span>Agile (Scrum,
        Kanban)
      </>
    );
  };
  return (
    <>
      {!isSmallScreen && (
        <div className={`${s.global} row`}>
          <div className={`${s.box1} col-8 col-md-6 order-2 order-md-1`}>
            {presentation()}
          </div>
          <div
            className={`${s.textContent} ${s.box2} col-8 col-md-6 order-3 order-md-2`}
          >
            {technos()}
          </div>
          <div
            id="anim"
            className={`col-4 col-md-12 order-1 order-md-3 d-flex align-items-end justify-content-center ${s.containerAnims}`}
          >
            <Animation isSmallScreen={isSmallScreen} />
          </div>
        </div>
      )}
      {isSmallScreen && (
        <div className={`${s.global} row`}>
          <div className={`col-3 ${s.containerAnims}`}>
            <Animation isSmallScreen={isSmallScreen} />
          </div>
          <div className={`${s.englobe} col-9`}>
            <div className={`${s.box1}`}>{presentation()}</div>
            <div className={`${s.textContent} ${s.box2}`}>{technos()}</div>
          </div>
        </div>
      )}
    </>
  );
}
